export const loadCSS = () => {
  if (process.env.REACT_APP_COUNTRY === "AU") {
    return import("pr-utility/sass/style.scss");
  } else if (process.env.REACT_APP_COUNTRY === "US") {
    return import("pr-utility/sass/style.scss");
  }
};
